import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../constants';
export const useIsBmHarmonyThemeEnabled = () => {
  const {
    experiments
  } = usePremiumEssentialsContext(false) ?? {};
  return Boolean(experiments == null ? void 0 : experiments[ExperimentSpecs.BmHarmonyTheme]);
};
//# sourceMappingURL=harmonyTheme.js.map